import actionTypes from "../actionTypes";
import IAction from "../../types/IAction";
import {
  successNotification,
  errorNotification
} from "../../utils/notifications";

interface State {
  configuraciones: any[];
  mantenimientos: any[];
  clubes: any[];
  searching: boolean;
  saving: boolean;
  updating: boolean;
  deleting: boolean;
}

const initialState: State = {
  configuraciones: [],
  mantenimientos: [],
  clubes: [],
  searching: false,
  saving: false,
  updating: false,
  deleting: false
};

export default function horariosClubesReducer(
  state: State = initialState,
  action: IAction
): State {
  const snapshot = snapshotAction(state, action);

  state != snapshot &&
    !action.type.endsWith("_PENDING") &&
    action.meta &&
    action.meta.resolver &&
    action.meta.resolver({
      fulfilled: action.type.endsWith("_FULFILLED"),
      ...snapshot
    });

  return state != snapshot
    ? {
        ...state,
        ...snapshot
      }
    : state;
}

function snapshotAction(
  state: State = initialState,
  action: IAction
): Partial<State> {
  switch (action.type) {
    case `${actionTypes.GET_CONFIGURACIONES_HORARIOS_CLUBES}_FULFILLED`: {
      return {
        ...state,
        searching: false,
        configuraciones: action.payload.data || []
      };
    }

    case `${actionTypes.GET_MANTENIMIENTOS}_FULFILLED`: {
      return {
        ...state,
        mantenimientos: action.payload.data || []
      };
    }

    case `${actionTypes.GET_CLUBES}_FULFILLED`: {
      return {
        ...state,
        clubes: action.payload.data || []
      };
    }

    case `${actionTypes.POST_CONFIGURACIONES_HORARIOS_CLUBES}_FULFILLED`: {
      successNotification("Configuración creada correctamente");
      return {
        ...state,
        saving: false,
        configuraciones: [...state.configuraciones, action.payload.data]
      };
    }

    case `${actionTypes.PUT_CONFIGURACIONES_HORARIOS_CLUBES}_FULFILLED`: {
      successNotification("Configuración actualizada correctamente");
      return {
        ...state,
        updating: false,
        configuraciones: state.configuraciones.map(config =>
          config.configuracionId === action.payload.data.configuracionId
            ? action.payload.data
            : config
        )
      };
    }

    case `${actionTypes.DELETE_CONFIGURACIONES_HORARIOS_CLUBES}_FULFILLED`: {
      successNotification("Configuración eliminada correctamente");
      return {
        ...state,
        deleting: false
      };
    }

    case `${actionTypes.GET_CONFIGURACIONES_HORARIOS_CLUBES}_REJECTED`: {
      const errorMessage = action.payload.response.data.message;
      errorNotification(errorMessage);
      return { ...state, searching: false };
    }

    case `${actionTypes.POST_CONFIGURACIONES_HORARIOS_CLUBES}_REJECTED`: {
      const errorMessage = action.payload.response.data.message;
      errorNotification(errorMessage);
      return { ...state, saving: false };
    }

    case `${actionTypes.PUT_CONFIGURACIONES_HORARIOS_CLUBES}_REJECTED`: {
      const errorMessage = action.payload.response.data.message;
      errorNotification(errorMessage);
      return { ...state, updating: false };
    }

    case `${actionTypes.DELETE_CONFIGURACIONES_HORARIOS_CLUBES}_REJECTED`: {
      const errorMessage = action.payload.response.data.message;
      errorNotification(errorMessage);
      return { ...state, deleting: false };
    }

    case `${actionTypes.GET_CONFIGURACIONES_HORARIOS_CLUBES}_PENDING`: {
      return { ...state, searching: true };
    }
    case `${actionTypes.POST_CONFIGURACIONES_HORARIOS_CLUBES}_PENDING`: {
      return { ...state, saving: true };
    }
    case `${actionTypes.PUT_CONFIGURACIONES_HORARIOS_CLUBES}_PENDING`: {
      return { ...state, updating: true };
    }
    case `${actionTypes.DELETE_CONFIGURACIONES_HORARIOS_CLUBES}_PENDING`: {
      return { ...state, deleting: true };
    }

    default: {
      return state;
    }
  }
}
